import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  FormHelperText,
} from '@mui/material';
import { getSearchListChannels } from '../../services/content.service';
import {
  CONTENT_ALIAS,
  LS_ADMIN_USER_ID,
} from '../../config/const.config';
import { getLocalValue,checkAdminUserRole } from '../../utils/local-cache.util';

const FilterChannels = ({
  id,
  name,
  defaultValue,
  label,
  onChange,
  sx,
  error,
  disabled,
  allowAllOptions,
  showSelectCatOption,
  addDefault,
  menuProps,
  parentSx,
  labelSx,
  
}) => {

  const [booksData, setBooksData] = useState([]);

  useEffect(() => {
    const adminUserId = getLocalValue(LS_ADMIN_USER_ID);
    const adminUserRole = checkAdminUserRole();
    const params = {
      adminUserId,
      adminUserRole
    }
    getSearchListChannels(params)
      .then((res) => {
        setBooksData(res.data);
      })
      .catch(() => {
        // nothing
      });
  }, []);

  return (
    <FormControl
      fullWidth={!addDefault}
      error={error !== ''}
      sx={addDefault && parentSx}
    >
      <InputLabel id={`field-${id}-select-label`} 
        sx={addDefault && labelSx}
        style={{color:"#9369a8"}}
      >
        {label}
      </InputLabel>

      <Select
        labelId="demo-simple-select-label"
        id={id}
        name={name}
        value={defaultValue}
        label={label}
        onChange={onChange}
        sx={sx}
        disabled={disabled}
        MenuProps={addDefault && menuProps}
      >
        {allowAllOptions && (
          <MenuItem key={`${id}-v-`} value="All">
            {`All ${CONTENT_ALIAS.CHANNEL_PLURAL}`}
          </MenuItem>
        )}
        {showSelectCatOption && (
          <MenuItem key={`${id}-v-`} value={null}>
            {`-- Select ${CONTENT_ALIAS.CHANNEL_SINGULAR} --`}
          </MenuItem>
        )}
        {booksData.map((k) => (
          <MenuItem
            key={`${id}-v-${k.id}`}
            value={`${k.id}`}
            sx={{ color: `${k.status === 0 ? 'grey' : ''}` }}
          >
            {`${k.title}`}
          </MenuItem>
        ))}
      </Select>

      {error !== '' && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

FilterChannels.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  defaultValue: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  sx: PropTypes.shape(),
  error: PropTypes.string,
  disabled: PropTypes.bool,
  allowAllOptions: PropTypes.bool,
  showSelectCatOption: PropTypes.bool,
  addDefault: PropTypes.bool,
  menuProps: PropTypes.object,
  parentSx: PropTypes.object,
  labelSx: PropTypes.object,
};
FilterChannels.defaultProps = {
  sx: {},
  error: '',
  disabled: false,
  allowAllOptions: false,
  showSelectCatOption: false,
  addDefault: false,
  menuProps: {},
  parentSx: {},
  labelSx: {},
};

export default FilterChannels;
